import { Link } from "react-router-dom";
import { Instagram, Youtube, Mail, MapPin, MessageCircle } from "lucide-react";
import { useSettings } from "../lib/settings";
import { TikTokIcon } from "./SocialIcons";

const FOOTER_LINKS = [
  { to: "/", label: "Accueil" },
  { to: "/qui-sommes-nous", label: "Notre vision" },
  { to: "/premiere-visite", label: "Première visite" },
  { to: "/agenda", label: "Agenda" },
  { to: "/predications", label: "Prédications" },
  { to: "/priere", label: "Prière" },
  { to: "/donner", label: "Donner" },
  { to: "/contact", label: "Contact" },
];

export default function Footer() {
  const { settings } = useSettings();
  return (
    <footer data-testid="site-footer" className="bg-obsidian text-stone-300">
      <div className="container-site grid gap-12 py-16 md:grid-cols-[1.4fr_1fr_1fr] md:py-20">
        <div>
          <span className="inline-flex rounded-xl bg-cream px-4 py-2">
            <img src="/logo.png" alt="La Maison de la Charité" className="h-14 w-auto" />
          </span>
          <p className="verse-quote mt-5 !text-stone-300">« Car Dieu est Amour »</p>
          <p className="mt-1 font-mono text-xs uppercase tracking-[0.2em] text-stone-500">1 Jean 4:7</p>
          <p className="mt-6 flex items-start gap-2 text-sm text-stone-400">
            <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-terracotta" />
            {settings.city_line}
          </p>
          <div className="mt-6 flex items-center gap-3">
            {settings.instagram && (
              <a data-testid="footer-instagram" href={settings.instagram} target="_blank" rel="noreferrer" aria-label="Instagram"
                className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-stone-300 transition-colors hover:border-terracotta hover:text-terracotta">
                <Instagram className="h-4 w-4" />
              </a>
            )}
            {settings.youtube && (
              <a data-testid="footer-youtube" href={settings.youtube} target="_blank" rel="noreferrer" aria-label="YouTube"
                className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-stone-300 transition-colors hover:border-terracotta hover:text-terracotta">
                <Youtube className="h-4 w-4" />
              </a>
            )}
            {settings.tiktok && (
              <a data-testid="footer-tiktok" href={settings.tiktok} target="_blank" rel="noreferrer" aria-label="TikTok"
                className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-stone-300 transition-colors hover:border-terracotta hover:text-terracotta">
                <TikTokIcon className="h-4 w-4" />
              </a>
            )}
            {settings.whatsapp && (
              <a data-testid="footer-whatsapp" href={settings.whatsapp} target="_blank" rel="noreferrer" aria-label="WhatsApp"
                className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-stone-300 transition-colors hover:border-terracotta hover:text-terracotta">
                <MessageCircle className="h-4 w-4" />
              </a>
            )}
            {settings.contact_email && (
              <a data-testid="footer-email" href={`mailto:${settings.contact_email}`} aria-label="Email"
                className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-stone-300 transition-colors hover:border-terracotta hover:text-terracotta">
                <Mail className="h-4 w-4" />
              </a>
            )}
          </div>
        </div>
        <nav aria-label="Liens de pied de page">
          <p className="label-eyebrow !text-stone-500">Le site</p>
          <ul className="mt-5 space-y-3">
            {FOOTER_LINKS.map((l) => (
              <li key={l.to}>
                <Link data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`} to={l.to} className="text-sm text-stone-400 transition-colors hover:text-cream">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
        <div>
          <p className="label-eyebrow !text-stone-500">Informations</p>
          <ul className="mt-5 space-y-3">
            <li><Link data-testid="footer-link-mentions-legales" to="/mentions-legales" className="text-sm text-stone-400 transition-colors hover:text-cream">Mentions légales</Link></li>
            <li><Link data-testid="footer-link-confidentialite" to="/politique-de-confidentialite" className="text-sm text-stone-400 transition-colors hover:text-cream">Politique de confidentialité</Link></li>
            <li><Link data-testid="footer-link-ce-que-nous-croyons" to="/ce-que-nous-croyons" className="text-sm text-stone-400 transition-colors hover:text-cream">Ce que nous croyons</Link></li>
            <li><Link data-testid="footer-link-temoignages" to="/temoignages" className="text-sm text-stone-400 transition-colors hover:text-cream">Témoignages</Link></li>
          </ul>
          <p className="mt-8 text-sm leading-relaxed text-stone-500">
            « Bien-aimés, aimons-nous les uns les autres ; car l'amour est de Dieu. »
          </p>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container-site flex flex-col gap-2 py-6 text-xs text-stone-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} La Maison de la Charité — Église évangélique, Montévrain / Val d'Europe.</p>
          <p>Bienvenue à la maison.</p>
        </div>
      </div>
    </footer>
  );
}
